import { Table, Card } from "@velocity-ehs/component-library";
import { Column } from "primereact/column";
import { DataTableSelectEvent } from "primereact/datatable";
import { ChangeEvent, useCallback, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";
import { useGetUserRoleLocationCount } from "../../../hooks/useGetRoleLocationCount";
import { SortDirection } from "../../supportFunctions/graphql/Queries";

const defaultParams = {
  first: 0,
  rows: 20,
  page: 0,
  sortField: "roleName",
  sortOrder: SortDirection.ASC,
  filters: {
    roleName: {
      value: null,
    },
  },
};

const LocationsRoleAssignment = () => {
  const { id } = useParams() as { id: string };

  const { t } = useTranslation();

  const history = useHistory();

  const [lazyParams, setLazyParams] = useState(defaultParams);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const { userRoleLocationCount, pagination, isFetching } =
    useGetUserRoleLocationCount(lazyParams, { id });

  useEffect(() => {
    pagination.totalElements && setTotalRecords(pagination.totalElements);
  }, [pagination.totalElements]);

  const handleGlobalSearch = useCallback(
    (event: ChangeEvent<HTMLInputElement>) =>
      setLazyParams((previous) => ({
        ...previous,
        filters: {
          ...previous.filters,
          roleName: {
            value: event.target.value,
          },
        },
      })),
    []
  );

  const handleSelect = ({
    data,
  }: {
    data: { roleID: string; roleName: string; locationID: string };
  }) => {
    history.push(
      `/role-management/location-roles/${data.roleID}?roleName=${data.roleName}&locationID=${data.locationID}`
    );
  };

  return (
    <>
      <h2>{t("meta_role_assignments")}</h2>
      <Card showHeader={false} full>
        <Table
          data={userRoleLocationCount}
          params={lazyParams}
          totalRecords={totalRecords}
          onPage={setLazyParams}
          onSort={setLazyParams}
          isLoading={isFetching}
          onGlobalSearch={handleGlobalSearch}
          fullPage={false}
          selectionMode="single"
          onRowSelect={(e: DataTableSelectEvent) => handleSelect(e)}
        >
          <Column field="roleName" header={t("universal_Role")} />
          <Column field="roleDescription" header={t("universal_Description")} />
          <Column
            field="count"
            header={t("universal_number_of_users")}
            sortable
            body={(rowData) => <span>{rowData.count ?? "--"}</span>}
          />
        </Table>
      </Card>
    </>
  );
};

export default LocationsRoleAssignment;
